// src/utils/auth.ts
export function getCurrentUser() {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    return null;
  }
}
// OWNER
export function isOwner() {
  const user = getCurrentUser();

  return (
    user &&
    user.username &&
    user.username.toLowerCase() === "kevin"
  );
}
export function isAdmin() {
  const user = getCurrentUser();
  return user && Number(user.role) === 0;
}
export function canSeeDashboard() {
  return isOwner();
}